import { render, staticRenderFns } from "./DetailHistoryOrder.vue?vue&type=template&id=7f6df62e&scoped=true&"
import script from "./DetailHistoryOrder.vue?vue&type=script&lang=js&"
export * from "./DetailHistoryOrder.vue?vue&type=script&lang=js&"
import style0 from "./DetailHistoryOrder.vue?vue&type=style&index=0&id=7f6df62e&lang=scss&scoped=true&"
import style1 from "./DetailHistoryOrder.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f6df62e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSimpleTable } from 'vuetify/lib/components/VDataTable';
import { VTextarea } from 'vuetify/lib/components/VTextarea';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VBtn,VCard,VCol,VIcon,VRow,VSimpleTable,VTextarea,VTooltip})
